// removed by extract-text-webpack-plugin
module.exports = {"box":"_2NjSr0AlISerOg3vGRVRXv","col":"_2oVNgLa6rHL18fy_OBNgfX","item":"HuqxyAiEeZd1PIbo0FabX"};


//////////////////
// WEBPACK FOOTER
// ./src/SPRINTA/atoms/Masonry/style.css
// module id = 687
// module chunks = 38